<template>
  <router-view />
</template>

<script>

export default {
  name: 'AuthenticatedViews',
};
</script>
